import { observer } from "mobx-react";
import useTranslation from "../../../../translation/hooks/translation-hook";
import { Input } from "../../../../components/inputs/input/input";
import { Tooltip } from "../../../../components/tooltip/tooltip";
import FontBody2 from "../../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR } from "../../../../components/fonts/font-props";
import IconTranslationIndicator from "../../../../components/icons/icon-translation-indicator/icon-translation-indicator";
import NotificationTemplateStore from "../../stores/notification-template-store";
import { useEffect } from "react";

interface IProps {
    emailTemplateStore?: NotificationTemplateStore;
}

const TranslateInputSubject: React.FC<IProps> = observer(({ emailTemplateStore }: IProps) => {

    const { getTranslation, selectedLocale } = useTranslation();

    const subjectTranslation = getTranslation('SUBJECT')?.replace(/:(\w+)/g, '{{$1}}') || null;
    useEffect(() => {
        if (!emailTemplateStore?.getSubject(selectedLocale)) {
            emailTemplateStore?.setSubject(selectedLocale, subjectTranslation);
        }
    }, [subjectTranslation, emailTemplateStore, selectedLocale]);

    return (
        <div className='translation-input'>
            <Input
                value={emailTemplateStore?.getSubject(selectedLocale) ?? getTranslation('SUBJECT')?.replace(/:(\w+)/g, '{{$1}}')}
                onChange={(v) => { emailTemplateStore?.setSubject(selectedLocale, v) }}
            />
            <Tooltip content={<FontBody2 color={FONT_COLOR.NEUTRAL_WHITE}>Translatable field</FontBody2>}>
                <IconTranslationIndicator color={'var(--color-accent-1-50)'} />
            </Tooltip>
        </div>
    );
});

export default TranslateInputSubject;